var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    {
      attrs: {
        icon: "back",
        appBarTitle: _vm.channelName,
        route: _vm.backRoute,
      },
    },
    [
      _c("KPageContainer", { staticClass: "device-container" }, [
        !_vm.loadingChannel
          ? _c(
              "div",
              [
                _c("section", [
                  _c("h1", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.versionAvailableText) +
                        "\n        "
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$tr("youAreCurrentlyOnVersion", {
                            currentVersion: _vm.currentVersion,
                          })
                        )
                    ),
                  ]),
                  _vm.channelIsIncomplete
                    ? _c("p", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$tr("channelIsIncomplete", {
                                available: _vm.available,
                                total: _vm.total,
                              })
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "section",
                  [
                    _c("p", [
                      _c("strong", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$tr("versionChangesHeader", {
                                oldVersion: _vm.currentVersion,
                                newVersion: _vm.nextVersion,
                              })
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    !_vm.loadingChannel && !_vm.loadingTask
                      ? _c("table", [
                          _c("tr", [
                            _c("th", [
                              _vm._v(
                                _vm._s(_vm.$tr("resourcesAvailableForImport"))
                              ),
                            ]),
                            _c("td", { staticClass: "col-2" }, [
                              _c(
                                "span",
                                {
                                  class: { "count-added": _vm.newResources },
                                  style: { color: _vm.$themeTokens.success },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newResources) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("th", [
                              _vm._v(_vm._s(_vm.$tr("resourcesToBeDeleted"))),
                            ]),
                            _c("td", [
                              _c(
                                "span",
                                {
                                  class: {
                                    "count-deleted": _vm.deletedResources > 0,
                                  },
                                  style: { color: _vm.$themeTokens.error },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.deletedResources) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "td",
                              [
                                _vm.deletedResources
                                  ? _c("CoreInfoIcon", {
                                      staticClass: "info-icon",
                                      attrs: {
                                        tooltipText: _vm.$tr(
                                          "resourcesToBeDeletedTooltip"
                                        ),
                                        iconAriaLabel: _vm.$tr(
                                          "resourcesToBeDeletedTooltip"
                                        ),
                                        tooltipPlacement: "right",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _c("tr", [
                            _c("th", [
                              _vm._v(_vm._s(_vm.$tr("resourcesToBeUpdated"))),
                            ]),
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.updatedResources) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                        ])
                      : _c("KLinearLoader", {
                          attrs: { indeterminate: true, delay: false },
                        }),
                  ],
                  1
                ),
                _c(
                  "dl",
                  [
                    _vm._l(
                      _vm.sortedFilteredVersionNotes,
                      function (note, idx) {
                        return [
                          _c("dt", { key: "dt-" + idx }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$tr("versionNumberHeader", {
                                    version: note.version,
                                  })
                                ) +
                                "\n          "
                            ),
                          ]),
                          _c(
                            "dd",
                            { key: "dd-" + idx, attrs: { dir: "auto" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(note.notes) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      }
                    ),
                  ],
                  2
                ),
                _vm.showModal
                  ? _c(
                      "KModal",
                      {
                        attrs: {
                          title: _vm.$tr("updateChannelAction"),
                          submitText: _vm.coreString("continueAction"),
                          cancelText: _vm.coreString("cancelAction"),
                          disabled: _vm.disableModal,
                        },
                        on: {
                          submit: _vm.handleSubmit,
                          cancel: function ($event) {
                            _vm.showModal = false
                          },
                        },
                      },
                      [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$tr("updateConfirmationQuestion", {
                                channelName: _vm.channelName,
                                version: _vm.nextVersion,
                              })
                            )
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "BottomAppBar",
                  [
                    _c("KButton", {
                      attrs: {
                        text: _vm.$tr("updateChannelAction"),
                        appearance: "raised-button",
                        primary: true,
                        disabled: _vm.loadingChannel || _vm.loadingTask,
                      },
                      on: {
                        click: function ($event) {
                          _vm.showModal = true
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }